export const routes = {
    public: {
        signInPage: "/auth/sign-in",
        reqisterPage: "/auth/register",
        forgotPasswordPage: "/auth/forgot-password",
        forgotPasswordSuccessPage: "/auth/forgot-password/success",
        resetPasswordPage: "/auth/reset-password/:email/:code",
        popularSeriesListPage: "/popular-sermon-series",
        popularSeriesDetailPage: "/popular-sermon-series/:name",
        popularSermonListPage: "/popular-sermons",
        popularSermonDetailPage: "/popular-sermons/:name",
        googleAuthPage: "/googleauth",
        sharePage: "/share/:id",
        shareSlidePage: "/share/slide/:id",
        builderPreviewPage: "/builderPreview/:id",
        resolve: {
            signInPage: () => routes.public.signInPage,
            reqisterPage: (query:string) => `${routes.public.reqisterPage}${query}`,
            forgotPasswordPage: () => routes.public.forgotPasswordPage,
            forgotPasswordSuccessPage: () => routes.public.forgotPasswordSuccessPage,
            resetPasswordPage: (email:string, code:string) => `/auth/reset-password/${email}/${code}`,
            popularSeriesListPage: () => routes.public.popularSeriesListPage,
            popularSeriesDetailPage: (name:string) => `/popular-sermon-series/${name}`,
            popularSermonListPage: () => routes.public.popularSermonListPage,
            popularSermonDetailPage: (name:string) => `/popular-sermons/${name}`,
            googleAuthPage: () => routes.public.googleAuthPage,
            sharePage: (id:string) => `/share/${id}`,
            shareSlidePage: (id:string) => `/share/slide/${id}`,
            builderPreviewPage: (id:string) => `/builderPreview/${id}`,
        }
    },
    app: {
        libraryHomePage: "/library-home",
        libraryRecentPage: "/library-recent",
        libraryStarredPage: "/library-starred",
        librarySearchPage: "/library-search",
        libraryCalendarPage: "/library-calendar",
        libraryOfflinePage: "/library-offline",
        libraryFolder: "/library-home/:id",
        sermonTemplateListPage: "/sermon-templates",
        sermonTemplateDetailPage: "/sermon-templates/:id",
        premiumSermonListPage: "/premium-sermons",
        premiumSermonDetailPage: "/premium-sermons/:id",
        premiumSeriesListPage: "/premium-series",
        premiumSeriesDetailPage: "/premium-series/:id",
        builderPage: "/build/:id",
        presenterPage: "/present/:id",
        settings: "/settings",
        subscriptionConfirmationPage: "/confirmation",
        activatePage: "/activate",
        checkoutPage: "/checkout/:sessionId",
        resolve: {
            libraryHomePage: () => routes.app.libraryHomePage,
            libraryRecentPage: () => routes.app.libraryRecentPage,
            libraryStarredPage: () => routes.app.libraryStarredPage,
            librarySearchPage: (query: string | null) => `${routes.app.librarySearchPage}${query ? `?query=${query}` : ""}`,
            libraryCalendarPage: () => routes.app.libraryCalendarPage,
            libraryOfflinePage: () => routes.app.libraryOfflinePage,
            libraryFolder: (id:string) => `${routes.app.libraryHomePage}/${id}`,
            sermonTemplateListPage: (query?: string | null) => `${routes.app.sermonTemplateListPage}${query ? `?query=${query}` : ""}`,
            sermonTemplateDetailPage: (id:string) => `/sermon-templates/${id}`,
            premiumSermonListPage: (query?: string | null) => `${routes.app.premiumSermonListPage}${query ? `?query=${query}` : ""}`,
            premiumSermonDetailPage: (id:string) => `/premium-sermons/${id}`,
            premiumSeriesListPage: (query?: string | null) => `${routes.app.premiumSeriesListPage}${query ? `?query=${query}` : ""}`,
            premiumSeriesDetailPage: (id:string) => `/premium-series/${id}`,
            builderPage: (id:string) => `/build/${id}`,
            presenterPage: (id:string) => `/present/${id}`,
            settings: () => routes.app.settings,
            activatePage: (query:string) => `${routes.app.activatePage}${query}`,
            subscriptionConfirmationPage: () => routes.app.subscriptionConfirmationPage,
            checkoutPage: (sessionId:string) => `/checkout/${sessionId}`,
        }
    }
}